import { PLAN_KEY } from '../../../../modules/plan/model'
import getCurrentPlanSelect from '../get-current'

import getTrainingTimeDatePreferencesSelect from '../../../preferences/selectors/get-training-time-date'
import { getValueReduxUtil } from '../../../redux/utils/get-value'
import { createISOStrDateUtil, setHoursMinutesAndSecondsDateUtil } from 'packages/src'
import { createSelector } from 'reselect'

const getLocalStartAtPlanSelect = createSelector(
  getCurrentPlanSelect,
  getTrainingTimeDatePreferencesSelect,
  (plan, trainingTimeDate) => {
    const startAt = (
      getValueReduxUtil(plan, PLAN_KEY.LOCAL_START_AT) || createISOStrDateUtil()
    )
    return setHoursMinutesAndSecondsDateUtil(new Date(startAt), {
      hours: trainingTimeDate.getHours(),
      minutes: trainingTimeDate.getMinutes(),
      seconds: trainingTimeDate.getSeconds()
    })
  }
)

export default getLocalStartAtPlanSelect
